import { z } from 'zod';

// We only strictly need `access_token` from the token; everything else is
// shape-as-given. expires_in is sometimes a number, sometimes a numeric string
// depending on the deployment, so we accept both.
export const oauthTokenSchema = z
  .object({
    access_token: z.string().min(1),
    expires_in: z.union([z.number(), z.string()]).optional(),
    token_type: z.string().optional(),
  })
  .passthrough();

// Authorization response schema is intentionally permissive — different
// deployments (local vs staging vs prod) sometimes return slightly different
// shapes (e.g. clinician.id as int vs string, missing email, etc.). The login
// flow only consumes `reason` (for MFA) and `oauth_token.access_token`; the
// rest of the clinician object is captured verbatim and shoved into the auth
// store via passthrough.
export const userAuthorizationResponseSchema = z
  .object({
    success: z.boolean().optional(),
    reason: z.string().nullable().optional(),
    message: z.string().nullable().optional(),
    oauth_token: oauthTokenSchema.nullish(),
    clinician: z.record(z.unknown()).nullish(),
  })
  .passthrough();

export type UserAuthorizationResponse = z.infer<typeof userAuthorizationResponseSchema>;

export const apiErrorSchema = z.object({
  error: z.string().optional(),
  status_code: z.number().int().optional(),
  message: z.string().optional(),
  user_message_tr: z.string().nullable().optional(),
});

export type ApiError = z.infer<typeof apiErrorSchema>;

export const positiveIntId = z.coerce.number().int().positive();
